export default "__VITE_ASSET__4Y0$zUcR__"